export default __webpack_public_path__ + "static/media/9.e85b97e7.png";